/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UploadInputs */

const en_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload`)
};

const es_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir`)
};

const fr_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploader`)
};

const de_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochladen`)
};

const ja_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロード`)
};

const zh_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传`)
};

const ar_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفع`)
};

const id_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah`)
};

const it_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica`)
};

const ru_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузить`)
};

const pt_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer upload`)
};

const ko_upload = /** @type {(inputs: UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업로드`)
};

/**
* | output |
* | --- |
* | "Upload" |
*
* @param {UploadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upload = /** @type {((inputs?: UploadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UploadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload(inputs)
	if (locale === "es") return es_upload(inputs)
	if (locale === "fr") return fr_upload(inputs)
	if (locale === "de") return de_upload(inputs)
	if (locale === "ja") return ja_upload(inputs)
	if (locale === "zh") return zh_upload(inputs)
	if (locale === "ar") return ar_upload(inputs)
	if (locale === "id") return id_upload(inputs)
	if (locale === "it") return it_upload(inputs)
	if (locale === "ru") return ru_upload(inputs)
	if (locale === "pt") return pt_upload(inputs)
	return ko_upload(inputs)
});